import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'
import { MXSameCountryGroup } from '@/config/visit/addvisit/config.js'

let visitTemplate = ''
export function changeStatus (showStatus) {
  // console.log(showStatus, '传入的参数---')
  let arr = showStatus.split('_')
  visitTemplate = arr[3]
}
export const shopBusinessInfoStatusList = [
  {
    value: 0,
    icon: 'warn', // rich ui icon name 'richic-' + icon
    content: i18n.gettext('未完善')
  },
  {
    value: 1,
    icon: 'right',
    content: i18n.gettext('已完善')
  }
]
const shopBusinessInfoStatusMap = {}
const shopBusinessInfoIconMap = {}
shopBusinessInfoStatusList.forEach(item => {
  shopBusinessInfoStatusMap[item.value] = item.content
  item.icon && (shopBusinessInfoIconMap[item.value] = item.icon)
})
export const businessInfo = {
  label: i18n.gettext('营业信息'),
  type: 'visitSelProp',
  prop: 'businessInfoPerfect',
  props: {
    placeholder: i18n.gettext('设置'),
    map: shopBusinessInfoStatusMap,
    iconMap: shopBusinessInfoIconMap
  },
  rules: ['required', ['requireValue', i18n.gettext('营业信息'), 1]],
  checkVisible: (data) => {
    // 扩展信息 1 2 有合作意向 - 确定合作
    let ok1 = get(data, 'visitResult.value', []).includes(3) && get(data, 'visitResult.second[3].value', []).includes(10003)
    // 扩展信息 3
    let ok3 = visitTemplate === 'collect'
    // 扩展信息 8 9
    let ok8 = get(data, 'visitResult.value', []).includes(23)
    return ok1 || ok3 || ok8
  }
}

let PRICE_RANGE = []

// 营业信息 弹窗config
let hasPhotoAndPadModel = false
// pad 信息是否可以编辑
let padDisabled = false
const infoConfig = [
  {
    label: i18n.gettext('营业时间'),
    type: 'bizTime',
    prop: 'bizDayTime',
    props: {
      zindex: 51
    },
    rules: [['required', i18n.gettext('营业时间')]]
  },
  {
    label: i18n.gettext('订单均价'),
    type: 'rich-select',
    prop: 'customerPrice',
    props: {
      options: PRICE_RANGE,
      placeholder: i18n.gettext('请选择')
    },
    rules: [['required', i18n.gettext('订单均价')]]
  },
  {
    // 门店是否需要 平台帮助拍摄菜品 照片
    label: i18n.gettext('是否需要拍照'),
    type: 'rich-radio-group',
    prop: 'isNeedPic',
    props: {
      horizontal: true,
      options: [
        {
          value: 1,
          label: i18n.gettext('需要')
        },
        {
          value: 2,
          label: i18n.gettext('不需要')
        }
      ]
    },
    rules: [['required', i18n.gettext('是否需要拍照')]],
    checkVisible: () => {
      return hasPhotoAndPadModel
    }
  },
  {
    label: i18n.gettext('是否需要pad'),
    type: 'rich-radio-group',
    prop: 'isNeedPad',
    props: {
      horizontal: true,
      options: [
        {
          value: 1,
          label: i18n.gettext('需要'),
          disabled: false
        },
        {
          value: 2,
          label: i18n.gettext('不需要'),
          disabled: false
        }
      ]
    },
    rules: [['required', i18n.gettext('是否需要pad')]]
  },
  {
    label: i18n.gettext('PAD型号'),
    type: 'rich-radio-group',
    prop: 'padModel',
    props: {
      horizontal: true,
      options: [
        {
          value: 1,
          label: i18n.gettext('WIFI'),
          disabled: false
        },
        {
          value: 2,
          label: i18n.gettext('LTE'),
          disabled: false
        }
      ]
    },
    rules: [['required', i18n.gettext('PAD型号')]],
    checkVisible: (data) => {
      return hasPhotoAndPadModel && data.isNeedPad === 1
    }
  }
]

export const hasPropList = infoConfig.map(item => {
  return item.prop
})

// 营业信息 2 扩展信息 1 2
const infoMap2 = {
  hasPhotoAndPadModel: false,
  config: infoConfig,
  type: 'businessinfo',
  showFN ({ country, status }) {
    // 扩展信息 1 2
    let ok1 = MXSameCountryGroup.includes(country) && ['follow', 'draft', 'auditing', 'auditFail'].includes(status)
    return ok1
  }
}
// 营业信息 6 扩展信息 3 8 9
const infoMap6 = {
  hasPhotoAndPadModel: true,
  config: infoConfig,
  type: 'businessinfoall',
  showFN ({ country, status, way, content }) {
    // 扩展信息 3
    let ok3 = ['JP'].includes(country) && ['offline'].includes(way) && ['collect'].includes(content)
    // 扩展信息 8 9
    let ok8 = ['JP'].includes(country) && ['follow', 'draft', 'auditing', 'auditFail'].includes(status)
    return ok3 || ok8
  }
}
const showList = [
  infoMap2,
  infoMap6
]
const disabledPropList = [
  'isNeedPad',
  'padModel'
]
function filterInfoType (arr, obj) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].showFN(obj)) {
      return arr[i].type
    }
  }
  return ''
}
export function getBusinessInfoType (showStatus = '') {
  console.log(showStatus, 'showStatus----')
  // let arr = showStatus.split('_')
  // const obj = {
  //   country: arr[0],
  //   status: arr[1],
  //   way: arr[2],
  //   content: arr[3],
  //   showStatus: arr.splice(0, 4).join('_')
  // }
  // return filterInfoType(showList, obj)
}

function typeFilterInfo (arr, type) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].type === type) {
      hasPhotoAndPadModel = arr[i].hasPhotoAndPadModel
      return arr[i].config
    }
  }
  return []
}
function configDisabled (config, disabled) {
  if (padDisabled === disabled) {
    return config
  }
  padDisabled = disabled
  config.forEach(item => {
    if (disabledPropList.includes(item.prop) && item.props) {
      if (item.props.options) {
        item.props.options.forEach(opt => {
          opt.disabled = padDisabled
        })
      } else {
        item.props.disabled = padDisabled
      }
    }
  })
  return config
}
export function typeGetBusinessInfoConfig (type = '', disabled = false, range = []) {
  PRICE_RANGE.length = 0
  PRICE_RANGE.push(...range)
  let config = typeFilterInfo(showList, type)
  return configDisabled(config, disabled)
}
